import { ApiClient } from '../shared/api/api-client'
import { ClientAutofillResponse, ClientModel } from '../shared/models'

export class ClientApi {
    public static patchField(clientId: number, field: string, value: string) {
        return ApiClient.post('api/client/patchfield', {
            id: clientId,
            field,
            value,
        })
    }

    public static upsertClient(client: ClientModel) {
        return ApiClient.post('api/client/upsert', client)
    }

    public static get(clientId: number | string) {
        return ApiClient.get<ClientModel>(`api/client/get/${clientId}`)
    }

    public static delete(clientId: number) {
        return ApiClient.delete(`api/client/delete/${clientId}`)
    }

    public static getAutofill(oib: string) {
        return ApiClient.get<ClientAutofillResponse>(`api/client/autofill/${oib}`)
    }

    public static mapAutofillToClient(data: ClientAutofillResponse, oib: string): Partial<ClientModel> {
        return {
            name: data.name,
            address: data.headquatersAddress,
            city: data.headquatersCity,
            postalCode: data.headquatersZip,
            email: data.emailAddress,
            oib: oib,
            country: data.countryText,
        }
    }
}
